module.exports = __webpack_public_path__ + "static/img/logo_no_text.412baf3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_no_text.svg
// module id = Dg7J
// module chunks = 1